import { makeRoute } from "@flow/common/route";
import * as Safe from "safe-portals";
import { Serializers } from "@flow/common/types";
import { ConfigTypeSerializer, TargetLookupResultSerializer } from "./types";
import { IntegrationConfigSerializer } from "./types";
import * as perm from "@flow/common/core_permissions";

export const getMpdbLists = makeRoute(
  "/admin/api/plugin/mpdatabase/get_lists",
  [],
  Safe.nothing,
  Safe.array(
    Safe.obj({
      list_id: Safe.int,
      name: Safe.str,
    })
  )
);

export const getMpdbMemberships = makeRoute(
  "/admin/api/plugin/mpdatabase/get_memberships",
  [],
  Safe.obj({
    name: Safe.str,
  }),
  Safe.array(
    Safe.obj({
      membership_id: Safe.str,
      name: Safe.str,
      role: Safe.str,
    })
  )
);

export const lookupTargetByMember = makeRoute(
  "/api/plugin/mpdatabase/lookup_target_by_member",
  "public",
  Safe.obj({
    member: Serializers.member,
    config: ConfigTypeSerializer,
  }),
  TargetLookupResultSerializer
);

export const getIntegrationConfigSetting = makeRoute(
  "/admin/api/plugin/mpdatabase/get_integration_config_setting",
  [perm.VIEW_SETTINGS],
  Safe.nothing,
  IntegrationConfigSerializer
);

export const setIntegrationConfigSetting = makeRoute(
  "/admin/api/plugin/mpdatabase/set_integration_config_setting",
  [perm.UPDATE_SETTINGS],
  IntegrationConfigSerializer,
  Safe.nothing
);
